export default __webpack_public_path__ + "static/media/aws.b6e95e0a.svg";